import { EAlert, TaskType } from '@blade-sxp/monitor/interfaces/control';
export function getAlertFont(taskType, alertType) {
    switch (taskType) {
        case 0:
            if (alertType === EAlert.INCIDENT_VIRTUAL_REGION) {
                return 'areaOverLimit';
            }
            break;
        case 1:
            return 'warningFace';
        case 2:
            return '人流统计';
        case 3:
            return 'crowdRetention';
        case TaskType.Crowded:
            return 'crowded';
        case TaskType.CrossLine:
            return 'crowdCountercurrent';
        case 6:
            return 'regionalInvasion';
        case TaskType.DistanceTooClose:
            return 'distanceTooClose';
        case TaskType.Gathering:
            if (taskType === 8) {
                if (alertType === EAlert.INCIDENT_SCATTER) {
                    return 'crowdSpreadOut';
                }
                else if (alertType === EAlert.INCIDENT_CONGREGATE) {
                    return 'crowdgathering';
                }
            }
            break;
    }
    return '';
}
